export default __webpack_public_path__ + "static/ki-c051e4ec6c53ee2acdfcbd7c38782b93.svg";